export const Roles = {
    SUPER_ADMIN :  'admin',
    SL_SML :  'sml',
    SL_LANDLORD :  'landlord',
    SL_FRANCHISER: 'franchise',
    LL_TENANT: 'tenant',
    LL_SML: 'sml-ll',
    LL_ADMIN: 'll-admin',
    SL_ADMIN: 'sl-admin'
};